const CHART_TICK = {
	SM: {id: 1, size: 22, minutes:  5 },
	MD: {id: 2, size: 33, minutes: 15 },
	BG: {id: 3, size: 33, minutes: 30 },
};
const LOGIN_USER_CODE = '202';

const DISPLAY_LIST_TYPE = {
	MEMBER: 0,
	PROJECT: 1,
};

const SLIDE = {
	STATUS: {
		LEFT: -1,
		CENTER: 0,
	},
};

const INVALID_FLAG = {
	VALID: 0,
	INVALID: 1,
};

const PERMISSION = {
	ROLE: {
		GUEST: 1,
		SUB_MEMBER: 2,
		MEMBER: 3,
		ADMIN: 7,
		SYSTEM_ADMIN: 15,
	},
};

const _strftime = require('strftime');
const it_JA = {
	days: ['日', '月', '火', '水', '木', '金', '土'],
	shortDays: ['日', '月', '火', '水', '木', '金', '土'],
};
const strftime = _strftime.localize(it_JA);

const FORM_MODE = {
	EDIT: 1,
	REFERENCE: 2,
	ENTRY: 3,
};

const LIST_MODE = {
	REFERENCE: 0,
	SELECT: 1,
};

export {
	CHART_TICK,
	strftime,
	DISPLAY_LIST_TYPE,
	LOGIN_USER_CODE,
	SLIDE,
	LIST_MODE,
	INVALID_FLAG,
	PERMISSION,
	FORM_MODE,
	it_JA,
};
